import { useTranslation } from 'react-i18next';
import SearchableSelect from '../../searchableSelect/searchableSelect';
import { useMatterPhaseSelect } from './useMatterPhaseSelect';

interface MatterPhaseSelectProps {
  disabled: boolean;
  onOpenPicker: () => void;
  onClear: () => void;
}

/**
 * Its own component so the matter phase list is only fetched where the field is rendered. It
 * renders the trigger button directly, which lookup siblings like `LookupClearButton` rely on.
 */
const MatterPhaseSelect = ({
  disabled,
  onOpenPicker,
  onClear,
}: Readonly<MatterPhaseSelectProps>) => {
  const { t } = useTranslation();
  const select = useMatterPhaseSelect();

  return (
    <SearchableSelect
      {...select}
      disabled={disabled}
      ariaLabel={t('transaction:matterPhase')}
      placeholder={t('transaction:selectMatterPhase')}
      searchPlaceholder={t('transaction:searchMatterPhases')}
      onSearchIconClick={onOpenPicker}
      onClear={onClear}
      data-field="matterPhase"
      data-testid="add-matter-phase-button"
    />
  );
};

export default MatterPhaseSelect;
